var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.45 14.64a.5.5 0 0 1-.49.5H19.5c-.53 0-1.01-.39-1.05-.91-.03-.31.09-.6.29-.8a.95.95 0 0 1 .7-.29h1.51c.29.01.5.23.5.5v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.45 14.67c.26.93 1.17 1.52 2.13 1.52h.87c.55 0 1 .45 1 1v.19c0 2.07-1.69 3.76-3.76 3.76H6.21c-2.07 0-3.76-1.69-3.76-3.76v-6.73c0-1.23.59-2.32 1.5-3 .63-.48 1.41-.76 2.26-.76h11.48c2.07 0 3.76 1.69 3.76 3.76v.44c0 .55-.45 1-1 1h-1.02c-.56 0-1.07.22-1.44.6-.5.49-.74 1.22-.54 1.98zM15.86 5.51 8.18 5.5c-.44 0-.67-.54-.35-.85l1.62-1.63a3.525 3.525 0 0 1 4.96 0l1.75 1.77c.01.01.03.02.04.03.27.27.04.69-.34.69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldWallet);
export default __webpack_public_path__ + "static/media/vuesax-bold-wallet.98e4a24971798b06a2392a5b3722eaef.svg";
export { ForwardRef as ReactComponent };